import { formatMonthDayFromString } from '~/src/utils/date';

const IDENTITY_TESTING_FLAG_STORAGE_KEY = 'ls.DRAFT_IDENTITY_TESTING_FLAG';

export const formatDateStringToReadableDate = formatMonthDayFromString;

export const getIdentityTestingFlag = (): boolean => {
  return localStorage.getItem(IDENTITY_TESTING_FLAG_STORAGE_KEY) === 'true';
};
